import useSWR from 'swr';
import useSWRImmutable from 'swr/immutable';

export default class APIDocumentations {

  getHeadersWithContentType(arg0: string | undefined): HeadersInit | undefined {
    throw new Error("Method not implemented.");
  }

  getURLSearchParams(object: any) {
    throw new Error("Method not implemented.");
  }

  fetcher(url: string) {
    throw new Error("Method not implemented.");
  }

  async getDocumentationHTML(path_parts: string) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/documentations/html/${path_parts}`, {
      method: 'GET',
      headers: this.getHeadersWithContentType('application/json')
    });

    if (response.ok) {
      const text = await response.text();
      return text;
    }

    return false;
  }

  async syncDocumentations() {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/documentations/sync`, {
      method: 'GET',
      headers: this.getHeadersWithContentType('application/json')
    });

    return response.ok;
  }

  async updateDocumentation(id: number, content: any) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/documentations/${id.toString()}`, {
      method: 'PATCH',
      headers: this.getHeadersWithContentType('application/json'),
      body: JSON.stringify(content)
    });

    return response.ok;
  }

  async deleteDocumentation(id: number) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/documentations/${id.toString()}`, {
      method: 'DELETE',
      headers: this.getHeadersWithContentType('application/json')
    });

    return response.ok;
  }

  useDocumentations(query: any) {

    const params = this.getURLSearchParams(query);
    const endpoint = `${process.env.NEXT_PUBLIC_API_URL}/api/documentations/?${params}`
    const { data, error, isLoading, mutate } = useSWR(query ? endpoint : null, this.fetcher)

    return {
      data: data,
      error: error,
      isLoading: isLoading,
      mutate: mutate
    }
  }

  useDocumentationVersions(query: any) {

    const params = this.getURLSearchParams(query);
    const endpoint = `${process.env.NEXT_PUBLIC_API_URL}/api/documentations/versions/?${params}`
    const { data, error, isLoading, mutate } = useSWRImmutable(endpoint, this.fetcher)

    return {
      data: data,
      error: error,
      isLoading: isLoading,
      mutate: mutate
    }
  }
}